/**
 * Umumiy Zod schemalar (telefon, parol, UUID, va h.k.)
 *
 * Bu yagona haqiqat manbai — har joyda shu schema ishlatiladi.
 */
import { z } from 'zod';
// ─── UUID v4 ──────────────────────────────────────────────────────
export const uuidSchema = z.string().uuid({ message: "Noto'g'ri UUID format" });
// ─── O'zbek telefon raqami: +998 XX XXX XX XX ─────────────────────
// Qabul qilinadigan formatlar (oldindan tozalangan, faqat raqamlar saqlab):
//   +998901234567 → 901234567 (9 raqam, 90/91/93/94/95/97/98/99 prefix)
//   998901234567  → 901234567
//   901234567     → 901234567
export const phoneSchema = z
    .string()
    .min(9, 'Telefon raqami juda qisqa')
    .max(20, 'Telefon raqami juda uzun')
    .refine((val) => {
    const digits = val.replace(/\D/g, '').slice(-9);
    if (digits.length !== 9) {
        return false;
    }
    // O'zbek operator prefix tekshiruvi
    const prefix = digits.slice(0, 2);
    const validPrefixes = ['90', '91', '93', '94', '95', '97', '98', '99', '88', '33'];
    return validPrefixes.includes(prefix);
}, { message: "Noto'g'ri O'zbek telefon raqami (+998 XX XXX XX XX)" })
    .transform((val) => {
    // Normalize: +998 XXX XXX XX XX (kanonik bo'shliq formati)
    const digits = val.replace(/\D/g, '').slice(-9);
    return `+998 ${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 7)} ${digits.slice(7)}`;
});
// ─── Username (YARATISHDA — lotin, raqam, _, -) ───────────────────
// DIQQAT: bu regex FAQAT yangi username YARATISHDA ishlatiladi (toza format).
// LOGIN uchun `loginUsernameSchema` (pastda) ishlatiladi — login format
// tekshirmaydi, faqat DB'dagi mavjud username bilan solishtiradi.
export const usernameSchema = z
    .string()
    .min(3, 'Username kamida 3 ta belgi')
    .max(30, 'Username 30 ta belgidan oshmasligi kerak')
    .regex(/^[a-zA-Z0-9_-]+$/, "Username faqat lotin harflar, raqam, '_' va '-' bo'lishi mumkin");
// ─── Login username — FORMAT TEKSHIRILMAYDI ───────────────────────
// Login vaqtida username'ga format cheklovi qo'yilmaydi: mavjud (yoki boshqa
// yo'l bilan yaratilgan — masalan do'kon admini, migratsiya) username'lar
// kiril/probel bilan bo'lsa ham kira olishi kerak. Faqat bo'sh emasligi va
// uzunligi tekshiriladi; haqiqiy tekshiruv — DB'da topilishi (parol bilan).
export const loginUsernameSchema = z
    .string()
    .trim()
    .min(1, 'Username kiriting')
    .max(50, 'Username juda uzun');
// ─── Parol (sifat darvozasi: kuchli) ──────────────────────────────
export const passwordSchema = z
    .string()
    .min(8, 'Parol kamida 8 ta belgi')
    .max(128, 'Parol 128 ta belgidan oshmasligi kerak')
    .regex(/[a-z]/, "Parol kamida 1 ta kichik harf bo'lishi kerak")
    .regex(/[A-Z]/, "Parol kamida 1 ta katta harf bo'lishi kerak")
    .regex(/[0-9]/, "Parol kamida 1 ta raqam bo'lishi kerak");
// ─── Login parol (validation pasaytirilgan, faqat min/max) ────────
// Login paytida foydalanuvchi eski parolini ham kiritishi mumkin (kuchli emas)
export const loginPasswordSchema = z.string().min(1, 'Parol kiritilmagan').max(128);
// ─── Email (ixtiyoriy) ────────────────────────────────────────────
export const emailSchema = z.string().email({ message: "Noto'g'ri email format" }).max(100);
// ─── Pagination query ─────────────────────────────────────────────
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(20),
});
// ─── Date range query ─────────────────────────────────────────────
export const dateRangeSchema = z
    .object({
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
})
    .refine((val) => {
    if (val.from && val.to) {
        return new Date(val.from) <= new Date(val.to);
    }
    return true;
}, { message: "'from' sanasi 'to' dan keyin bo'lmasligi kerak" });
// ─── ID param (URL parametr uchun) ────────────────────────────────
export const idParamSchema = z.object({
    id: uuidSchema,
});
// ─── Money (Decimal — string sifatida API'da) ─────────────────────
// Prisma Decimal type — bu number bo'lsa precision yo'qoladi
// Shuning uchun API'da string sifatida uzatamiz, parse qilamiz
export const moneySchema = z
    .union([z.number(), z.string()])
    .transform((val) => {
    const num = typeof val === 'string' ? parseFloat(val) : val;
    if (isNaN(num)) {
        throw new Error("Noto'g'ri pul miqdori");
    }
    return num;
})
    .refine((val) => val >= 0, { message: "Pul miqdori manfiy bo'lmasligi kerak" })
    .refine((val) => val <= 1_000_000_000_000, { message: 'Pul miqdori juda katta' });
//# sourceMappingURL=common.schema.js.map